import { QueryClient } from 'react-query';

// Tempo de cache em milissegundos (60 segundos)
const cacheTimeMilliseconds = 60000;
// Tempo em milissegundos antes de considerar os dados como obsoletos
const staleTimeMilliseconds = 30000;

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      cacheTime: cacheTimeMilliseconds,
      staleTime: staleTimeMilliseconds,
    },
  },
});
